export const safeRender = (value, defaultText = 'расчет...', isTime = false) => {
  if (value === undefined || value === null || value === '') {
    return defaultText;
  }

  if (isTime) {
    if (typeof value === 'number') {
      if (value < 0) return defaultText; // Например, если время еще не рассчитано
      const totalSeconds = Math.round(value);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      if (minutes > 0) {
        return `${minutes} мин ${seconds} сек`;
      }
      return `${seconds} сек`;
    } else if (typeof value === 'string') {
      // Приоритет 1: Специальные строки-плейсхолдеры
      if (value.match(/вычисление|расчет/i)) {
        return value;
      }
      // Приоритет 2: Строка уже содержит единицы времени (более простой regex)
      if (value.match(/(сек|мин|час|дн)/i)) {
         return value;
      }
      // Приоритет 3: Строка является чисто числовой (например, "120")
      const trimmedValue = value.trim();
      if (/^\d+$/.test(trimmedValue)) { // Проверка, что строка состоит только из цифр
        const numericValue = parseInt(trimmedValue, 10);
        // Здесь parseInt точно сработает и вернет полное число
        const minutes = Math.floor(numericValue / 60);
        const seconds = numericValue % 60;
        if (minutes > 0) {
          return `${minutes} мин ${seconds} сек`;
        }
        return `${seconds} сек`;
      }
      // Приоритет 4: Нераспознанный формат строки для времени
      return defaultText; // Возвращаем текст по умолчанию
    }
  }
  
  return value;
};

// Сюда можно будет добавлять другие утилиты форматирования/отображения 